import {
  SendContentType,
  WechatFileMessageType,
  WechatImageMessageType,
  WechatLinkMessageType,
  WechatMiniProgramMessageType,
  WechatMsgType,
  WechatVideoMessageType,
  WechatVideoNumMessageType,
} from "../../types";
import {
  WechatFileSendData,
  WechatGifSendData,
  WechatImageSendData,
  WechatLinkSendData,
  WechatMiniProgramSendData,
  WechatSendDataType,
  WechatVideoNumSendData,
  WechatVideoSendData,
} from "./send-message";

const baseMessage = {
  chat_id: "",
  another_id: "",
  conversation_id: "",
  msg_server_id: "",
  msg_unique_identifier: "",
  request_key: "",
  sender_id: "",
  timestamp: 0,
  from_user_id: "",
  invoke_msg_type: 0,
  invoke_msg_unique_identifier: "",
  robot_task_id: "",
};

export const convertSendDataToWechatMessage = (data: WechatSendDataType) => {
  const { type } = data;
  switch (type) {
    case SendContentType.IMAGE: {
      const send_data = data.send_data as WechatImageSendData;
      return {
        ...baseMessage,
        msg_type: WechatMsgType.WECOM_IMAGE,
        file_url: send_data?.path,
        file_name: send_data?.file_name,
      } as WechatImageMessageType;
    }
    case SendContentType.GIF: {
      const send_data = data.send_data as WechatGifSendData;
      return {
        ...baseMessage,
        msg_type: WechatMsgType.GIF,
        file_url: send_data?.path,
        file_name: send_data?.file_name,
      };
    }
    case SendContentType.VIDEO: {
      const send_data = data.send_data as WechatVideoSendData;
      return {
        ...baseMessage,
        msg_type: WechatMsgType.VIDEO,
        file_url: send_data?.path,
        file_name: send_data?.file_name,
      } as WechatVideoMessageType;
    }
    case SendContentType.VIDEO_NUM: {
      const send_data = data.send_data as WechatVideoNumSendData;
      return {
        ...baseMessage,
        msg_type: WechatMsgType.VIDEO_NUM,
        channel_name: send_data.channel_name,
        channel_url: send_data?.channel_url,
        encode_data: send_data?.encode_data,
        head_img_url: send_data?.head_img_url,
        username: send_data?.username,
        thumburl: send_data?.thumb_url,
      } as WechatVideoNumMessageType;
    }
    case SendContentType.LINK: {
      const send_data = data.send_data as WechatLinkSendData;
      return {
        ...baseMessage,
        msg_type: WechatMsgType.LINK,
        title: send_data.title,
        desc: send_data?.desc,
        thumburl: send_data.thumburl,
        url: send_data.url,
      } as WechatLinkMessageType;
    }
    case SendContentType.MINI_PROGRAM: {
      const send_data = data.send_data as WechatMiniProgramSendData;
      return {
        ...baseMessage,
        msg_type: WechatMsgType.MINI_PROGRAM,
        title: send_data.title,
        desc: send_data.desc,
        headimg: send_data.thumburl,
        appid: send_data.appid,
        cover_image_aeskey: send_data.cover_file_aeskey,
        cover_image_id: send_data.cover_file_id,
        cover_image_md5: send_data.cover_file_md5,
        cover_image_size: send_data.cover_file_size,
        username: send_data.username,
      } as WechatMiniProgramMessageType;
    }
    case SendContentType.FILE: {
      const send_data = data.send_data as WechatFileSendData;
      return {
        ...baseMessage,
        msg_type: WechatMsgType.WECOM_FILE,
        file_url: send_data?.path,
        file_name: send_data?.file_name,
      } as WechatFileMessageType;
    }
  }
};
